import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';
import {isFirstLoad} from 'nutshell-core/utils/graphql-loading';

import type {
    GetActivitiesForWidget as GetActivitiesForWidgetQuery,
    GetActivitiesForWidget_activities as Activity,
    GetActivitiesForWidgetVariables,
} from 'nutshell-graphql-types';

import GET_ACTIVITIES_FOR_WIDGET from '../queries/get-activities-for-widget.graphql';

export const useGetActivitiesForWidget = (
    entityId: string,
    status: number,
    activityTypes?: string[] | null,
    skip: boolean = false
): {
    activities: Activity[] | null | undefined;
    isLoading: boolean;
    isFirstLoad: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch, networkStatus} = useQuery<
        GetActivitiesForWidgetQuery,
        GetActivitiesForWidgetVariables
    >(GET_ACTIVITIES_FOR_WIDGET, {
        variables: {
            entityId,
            status,
            activityTypes,
            sortOrder: status === 1 ? 'DESC' : 'ASC',
        },
        fetchPolicy: 'cache-and-network',
        skip,
    });

    return {
        activities: data && data.activities,
        isLoading: loading,
        isFirstLoad: isFirstLoad(networkStatus),
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
